const { createContext } = require("react");

const CartContext = createContext();

export default CartContext;